import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    consumptions: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_CONSUMPTIONS_SELECT_IDS (store, ids) {
      store.consumptions.selectIds = ids
    },
    REMOVE_CONSUMPTIONS_SELECT_IDS (store, ids) {
      store.consumptions.selectIds = store.consumptions.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CONSUMPTIONS_SELECT_ID (store, id) {
      store.consumptions.selectId = id
    },
    SET_CONSUMPTIONS_FILTERS (store, filters) {
      store.consumptions.filters = filters
    },
    SET_CONSUMPTIONS_PAGINATE (store, val) {
      store.consumptions.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getConsumptions: (store, getters) => {
      return store.consumptions.selectIds.map((id) => {
        return getters['entities/consumptions/find'](id)
      })
    },
    getConsumptionsFilters: (store, getters) => {
      return store.consumptions.filters
    },
    getConsumptionsPaginate: (store, getters) => {
      return store.consumptions.paginate
    },
    getConsumption: (store, getters) => {
      return getters['entities/consumptions/find'](store.consumptions.selectId) || {}
    }
  },
  actions: {
    /*
    selectConsumptions
    */
    selectConsumptions ({commit, dispatch, getters, state}, filters) {
      return dispatch('getConsumptions', filters)
      .then((response) => {
        commit('SET_CONSUMPTIONS_FILTERS', filters)
        commit('SET_CONSUMPTIONS_PAGINATE', response)
        commit('SET_CONSUMPTIONS_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectConsumptions
    */
    refreshSelectConsumptions ({commit, dispatch, getters, state}) {
      return dispatch('selectConsumptions', getters.getConsumptionsFilters)
    },
    /*
    selectConsumption
    */
    selectConsumption ({commit, dispatch, getters, state}, id) {
      return dispatch('getConsumptionById', id)
      .then((response) => {
        commit('SET_CONSUMPTIONS_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getConsumptions
    */
    getConsumptions ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/consumptions/${filters.type}/items`, {params: filters})
      .then((response) => {
        return dispatch('entities/consumptions/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.consumptions || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getConsumptionById
    */
    getConsumptionById ({commit, dispatch, getters, state}, params) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/consumptions/${params.type}/items/${params.id}`)
      .then((response) => {
        return dispatch('entities/consumptions/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.consumptions[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Consumption.js